import React from 'react';
import Layout from 'antd/lib/layout';
import Input from 'antd/lib/input';
import cn from 'classnames';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import { Menu } from '@headlessui/react';
import { FaBell } from 'react-icons/fa';
import Badge from 'antd/lib/badge';
import { HiOutlineCog } from 'react-icons/hi';
import { useDispatch, useSelector } from 'react-redux';
import UserMenuDropdown from './UserMenuDropdown';
import { RootState } from 'app/store';
import { updateIsCollapseNav } from '@slice/select.slice';
import ThemSelect from '@components/settingSelect/ThemeSelect';
import LanguageSetting from '@components/settingSelect/LanguageSetting';
import DropdownResultSearch from './DropdownResultSearch';
import ListNotification from './ListNotification';
import ListHistoryNotifies from './ListHistoryNotifies';
import { updateOpenHistoryNoti } from '@slice/orderManager.slice';

const { Search } = Input;

type Props = {
  prefix?: string | React.ReactNode;
  theme?: any;
  className?: string;
  style?: React.CSSProperties;
  getPopupContainer?: any;
  mode?: any;
};

export default function Header({ prefix, className, theme, ...props }: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onSearch = (value: string) => console.log(value);
  const collapsed = useSelector((state: RootState) => state.select.isCollapsedNav);
  const listNotification = useSelector((state: RootState) => state.orderManager.listNotification);
  const openHistoryNoti = useSelector((state: RootState) => state.orderManager.openHistoryNoti);

  const onContextMenuBell = e => {
    e.preventDefault();
    // e.stopPropagation();
    dispatch(updateOpenHistoryNoti());
  };

  return (
    <WapperHeader
      theme={theme}
      className={cn('flex items-center justify-between !h-[45px] !p-0', className)}
      {...props}
    >
      <div className="inline-flex align-middle items-center">
        {collapsed && (
          <WapperButtom theme={theme} onClick={() => dispatch(updateIsCollapseNav(!collapsed))}>
            {collapsed ? <AiOutlineMenuUnfold size={16} /> : <AiOutlineMenuFold size={16} />}
          </WapperButtom>
        )}
        {prefix || <div />}
      </div>

      <div className="inline-flex align-middle items-center">
        {/* Thanh tìm kiếm nhanh chức năng */}
        <DropdownResultSearch />
        {/* Thông báo chuông (mở lên sẽ có list danh sách thông báo..) + Cài đặt: theme + ngôn ngữ */}
        <Menu>
          <Menu.Button onContextMenu={onContextMenuBell} className="flex flex-row items-center translate-x-[2px]">
            <Badge
              size="small"
              showZero={false}
              className="text-base !px-.5"
              count={listNotification.length}
              overflowCount={9999}
            >
              <div className="relative flex items-center justify-center cursor-pointer rounded-full w-8 h-8 content-center">
                <FaBell
                  className={cn(
                    listNotification.length > 0 ? 'bell' : '',
                    'w-5 h-5 text-green-600 hover:text-green-700'
                  )}
                />
              </div>
            </Badge>
          </Menu.Button>
          <Menu.Items className={'z-50'}>
            <FootMenu theme={theme} isCofig={false}>
              <ListNotification />
            </FootMenu>
          </Menu.Items>
        </Menu>
        <Menu>
          <Menu.Button className="flex flex-row items-center">
            <div className="relative flex items-center text-gray-400 hover:text-gray-500 justify-center cursor-pointer rounded-full w-9 h-9 content-center">
              <HiOutlineCog className="w-6 h-6 " />
            </div>
          </Menu.Button>
          <Menu.Items className={'z-50'}>
            <FootMenu theme={theme} isCofig={false}>
              <div className="inline-flex align-middle items-center">
                <ThemSelect />
                <LanguageSetting />
              </div>
            </FootMenu>
          </Menu.Items>
        </Menu>
        {openHistoryNoti && (
          <FootMenu theme={theme} isCofig={false}>
            <ListHistoryNotifies />
          </FootMenu>
        )}

        {/* thông tin user */}
        <UserMenuDropdown />
      </div>
    </WapperHeader>
  );
}

const FootMenu = styled.div.attrs({
  className:
    'fixed transform origin-left top-[3rem] right-3 z-20 w-fit text-base list-none rounded-md divide-y divide-gray-100 shadow-md'
})<{ theme?: any; isCofig?: any }>`
  background-color: ${({ theme }) => theme.colors!.background};
  color: ${({ theme }) => theme.colors!.text};
  right: ${({ isCofig }) => (isCofig ? '150px !important' : '')};
`;

const WapperButtom = styled.div.attrs({
  className: 'cursor-pointer p-1 hover:bg-blue-400 hover:text-white rounded-full'
})<{ theme?: any }>`
  background-color: ${({ theme }) => theme.colors!.background};
  color: ${({ theme }) => theme.colors!.text};
`;

const WapperHeader = styled(Layout.Header)<{ theme?: any }>`
  background-color: ${({ theme }) => theme.colors!.background};
  color: ${({ theme }) => theme.colors!.text + '!important'};
`;

export const StyleSearch: any = styled(Search)`
  &.ant-input-search {
    .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;
    }
    .ant-input-group .ant-input-affix-wrapper-focused:not(:last-child) {
      min-width: 350px;
      transform: translateX(-155px);
      transition: left 0.3s ease-in-out;
      -webkit-transition: left 0.3s ease-in-out;
      transition: left 0.3s ease-in-out;
      -webkit-transition: left 0.3s ease-in-out;
    }
    .ant-input-group .ant-input-suffix {
      transform: translateY(-3px) !important;
    }

    &.ant-input-search .ant-input-group .ant-input-group-addon:last-child {
      display: none;
    }
    // .ant-input-search-button:not(.ant-btn-primary) {
    //   border-top-right-radius: 10px;
    //   border-bottom-right-radius: 10px;
    //   transition-duration: 0s;
    //   transition-property: margin-right;
    //   display: none;
    // }
  }
`;
